import { Component } from '@angular/core';

@Component({
  selector: 'app-reviews-reports',
  templateUrl: './reviews-reports.component.html',
  styleUrls: ['./reviews-reports.component.less'],
})
export class ReviewsReportsComponent {
  constructor() {}
}
